import axios from 'axios';
import React, { useState, useLayoutEffect, useEffect } from 'react';
import { Modal } from 'react-bootstrap';
import { useDispatch, connect } from 'react-redux';
import { setOrderModal } from '../../../../redux/actions';
import { ReactSortable } from 'react-sortablejs';
import { useToasts } from "react-toast-notifications";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { isMobile } from 'react-device-detect';

import './style.scss';
import { s3Link } from '../../../utils/constants';
import { getAlbums, getStash, setStashAlbumMedias } from "../../../../redux/actions/stash";
import AlertConfirmModal from "../../../common/AlertConfirmModal";

const OrderModal = ({
    orderModal,
    activeAlbum,
    medias,
    album,
    pauseStashLoadMore,
    stashEnd,
}) => {
    const { addToast } = useToasts();

    const dispatch = useDispatch();

    const [page, setPage] = useState(1);
    const [perPage, setPerPage] = useState(40);
    const [hasReOrdered, setHasReOrdered] = useState(false);
    const [savedOrder, setSavedOrder] = useState(false);

    const [showAlert, setShowAlert] = useState(false);
    const [modalBody, setModalBody] = useState('');

    const handleHideModal = () => {
        if (hasReOrdered) {
            // reloadStash(activeAlbum, '', 'yes');
        }
        setHasReOrdered(false);
        dispatch(setOrderModal(false));
    };

    const handleOnSort = () => {
        setHasReOrdered(true);
    };

    const handleSave = async () => {
        const mediaIds = medias.map((media) => media.media_id);
        await axios.patch('/api/stash/reorder', {
            media_ids: mediaIds,
            album: activeAlbum,
        })
            .then((response) => {
                dispatch(getAlbums());
                setHasReOrdered(false);
                setSavedOrder(true);
                setModalBody('Media order updated');
                setShowAlert(true);
            })
            .catch((error) => {
                console.log({ error });
                addToast('Unable to update media order', { appearance: 'error', autoDismiss: true, autoDismissTimeout: 5000 });
            });
    };

    const albumScroll = () => {
        const wrappedElement = document.getElementById('albumBody');

        if (
            (
                wrappedElement.clientHeight + wrappedElement.scrollTop
                > (wrappedElement.scrollHeight - 20)
            ) && !pauseStashLoadMore
        ) {
            if (!stashEnd) {
                // reloadStash(activeAlbum, '', '');
            }
        }
    };

    useLayoutEffect(() => {
        if (orderModal) {
            const actionHeight = parseFloat($('.actions').height());
            $('.medias').css("margin-top", `${actionHeight + 30}px`);

            const bodyHeight = parseFloat($("#albumBody").height());
            $('.medias').css('max-height', `${bodyHeight - (actionHeight + 10)}px`);
        }
    }, [orderModal]);

    const setMedias = (medias) => {
        dispatch(setStashAlbumMedias(medias));
    };

    return (
        <>
            <Modal
                show={orderModal}
                size="lg"
                onHide={handleHideModal}
                className="order-modal"
                animation={false}
            >
                <Modal.Body id="albumBody" onScroll={albumScroll}>
                    <div className="actions mb-4">
                        <table cellPadding={0} cellSpacing={0} border={0} width="100%">
                            <tbody>
                                <tr>
                                    <td align='left' width="65%" style={{ lineHeight: '1.3' }} valign="middle">
                                        <strong style={{ fontSize: '24px' }}>Reorder {activeAlbum.album_name}</strong><br />
                                        Drag and drop the media into another position
                                    </td>
                                    <td align='right' valign="middle">
                                        <button
                                            type="button"
                                            className='btn btn-primary m-1'
                                            disabled={!hasReOrdered}
                                            onClick={handleSave}
                                        >Save</button>
                                        <button type="button" className='btn btn-primary m-1' onClick={handleHideModal}>
                                            {
                                                savedOrder ? 'Close' : 'Cancel'
                                            }
                                        </button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <ReactSortable
                        list={medias}
                        setList={setMedias}
                        className='medias'
                        animation={200}
                        onSort={handleOnSort}
                        draggable=".medias__media"
                        ghostClass="sortable-ghost"
                        chosenClass="sortable-chosen"
                        dragClass="sortable-drag"
                        scroll={true}
                        scrollSensitivity="100"
                        forceFallback={true}
                        scrollSpeed="100"
                    >
                        {
                            medias.map((media, index) => <div
                                className='medias__media'
                                key={`reorder-${index}-${media.media_album_id}-${media.media_id}`}
                            >
                                <div
                                    className="medias__media-item"
                                    style={{
                                        background: `url('${s3Link}/${media.thumb_path}') center center no-repeat`,
                                    }}
                                >
                                    {
                                        media.type.toLowerCase() == 'video' && <div className="medias__media-item-icon">
                                            <FontAwesomeIcon icon={['fas', 'video']} />
                                        </div>
                                    }
                                </div>
                            </div>
                            )
                        }
                    </ReactSortable>
                </Modal.Body>
            </Modal >
            {showAlert && <AlertConfirmModal show={showAlert} setShow={setShowAlert} modalBody={modalBody} />}
        </>
    );
};

function mapStateToProps(state) {
    return {
        orderModal: state.stash.orderModal,
        activeAlbum: state.stash.activeAlbum,
        medias: state.stash.activeAlbum.medias
    };
}

export default React.memo(connect(mapStateToProps)(OrderModal));
